import loadable from '@loadable/component';

/**
 * NotFoundPage for pages that render it in place when their resource does not
 * exist (unknown slug, deleted listing or user, invalid tab).
 *
 * A redirect to the NotFoundPage route is a <Navigate>, which does nothing in
 * the server render: crawlers got an empty page with status 200 (soft 404) and
 * only the browser moved on to /notfound. Rendered in place, NotFoundPage sets
 * the `notfound` flag on the SSR context and the server answers 404.
 */
const LoadableNotFoundPage = loadable(
  () => import(/* webpackChunkName: "NotFoundPage" */ './NotFoundPage'),
);

export default LoadableNotFoundPage;
